const TEAM_SCHEDULE_ROLES = new Set(['admin', 'creator', 'manager', 'viewer']);

export const canViewTeamSchedule = (roles: string[]): boolean => (
  roles.some(role => TEAM_SCHEDULE_ROLES.has(role.toLowerCase()))
);

export const storage = {
  getSelectedTeamId: (): string => localStorage.getItem('selected_team') ?? '',
  getSelectedTeamIdNum: (): number => parseInt(localStorage.getItem('selected_team') ?? '0', 10),
  getUserId: (): string => localStorage.getItem('userId') ?? '',
  getTeamsAndCompetences: () => {
    const data = localStorage.getItem('teams_and_competences');
    if (!data) return null;
    try {
      return JSON.parse(data);
    } catch {
      return null;
    }
  },
  getTeamIds: (): string[] => {
    try {
      const data = localStorage.getItem('teams_and_competences');
      if (!data) return [];
      const parsed = JSON.parse(data);
      return Object.keys(parsed?.teams ?? {});
    } catch {
      return [];
    }
  },
  setSelectedTeamId: (id: string | number) => {
    const prev = localStorage.getItem('selected_team');
    const next = String(id);
    localStorage.setItem('selected_team', next);
    if (prev !== next) {
      window.dispatchEvent(new CustomEvent('team-changed', { detail: next }));
    }
  },
  setUserId: (id: string) => localStorage.setItem('userId', id),
  getUserRolesForSelectedTeam: (): string[] => {
    try {
      if (sessionStorage.getItem('is_super_admin') === 'true') return ['admin'];
      const teamId = localStorage.getItem('selected_team');
      const data = JSON.parse(localStorage.getItem('teams_and_competences') || '{}');
      return data?.teams?.[teamId!]?.roles ?? [];
    } catch { return []; }
  },
  isManagerForSelectedTeam: (): boolean => {
    try {
      const teamId = localStorage.getItem('selected_team');
      const data = JSON.parse(localStorage.getItem('teams_and_competences') || '{}');
      const roles: string[] = data?.teams?.[teamId!]?.roles ?? [];
      return roles.includes('creator') || roles.includes('manager');
    } catch { return false; }
  },
};
